import { useCallback, useEffect, useMemo } from "react";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { PageRoutes } from "../../../constants/routes";
import { appActions } from "../../../ducks/app";
import { authActions } from "../../../ducks/auth";
import { useNavigation } from "../../../hooks/useNavigation";
import { AppDispatch } from "../../../store";

export const useSmsSend = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { navigateToPage } = useNavigation();
  const { state } = useLocation();
  const { password, phoneNumber, token, isActivation, isRegistration } =
    state ?? {};

  useEffect(() => {
    if (!phoneNumber || !token) return navigateToPage(PageRoutes.LOGIN);
  }, [phoneNumber, token]);

  const maskedPhoneNumber = useMemo(() => {
    return `*** **** ${phoneNumber?.slice(-4)}`;
  }, [phoneNumber]);

  const handleSmsSend = useCallback(() => {
    dispatch(appActions.showLoading());

    if (isActivation) {
      dispatch(
        authActions.sendActivationOtpToPhoneNumber.started({
          phone_number: phoneNumber,
          onComplete: () => dispatch(appActions.hideLoading()),
          onSuccess: (data) => {
            if (data.success) {
              navigateToPage(PageRoutes.SMS_SEND_COMPLETE, false, {
                password,
                phoneNumber,
                token,
                isActivation,
              });
            }
          },
        }),
      );
    } else {
      dispatch(
        authActions.sendOtpToPhoneNumber.started({
          session_token: token,
          onComplete: () => dispatch(appActions.hideLoading()),
          onSuccess: (data) => {
            if (data.success) {
              navigateToPage(PageRoutes.SMS_SEND_COMPLETE, false, {
                password,
                phoneNumber,
                token,
                isActivation,
              });
            }
          },
        }),
      );
    }
  }, []);

  const handleReSendEmail = useCallback(() => {
    dispatch(
      appActions.showModal({
        title: "電話番号を再設定しますか？",
        buttons: [
          {
            text: "閉じる",
            variant: "border",
            onClick: () => {
              dispatch(appActions.hideModal());
            },
          },
          {
            text: "再設定する",
            variant: "filled",
            onClick: () => {
              dispatch(appActions.hideModal());
              navigateToPage(PageRoutes.PHONE_NUMBER_SETTING, false, {
                token,
                password,
                isRegistration,
              });
            },
          },
        ],
      }),
    );
  }, []);

  return {
    maskedPhoneNumber,
    handleSmsSend,
    isRegistration,
    handleReSendEmail,
  };
};
